import React from "react";
import { arraysEqual } from 'helpers/utils'
import { usePositions } from "components/common/Positions";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { GGetSportsCode } from "../SportCode";
import { useGetParticipantNames } from "helpers/commonCodes";

export const AthleteEntriesExpanded = React.memo((props) => {
    let params = useUrlFriendlyToParameters()
    const { mirs_discipline } = params;
    const { row, sportEntryCodes, event } = props;
    const orderMap = new Map(sportEntryCodes.map(element => [element?.sportCode, element?.order?.trim()]));
    const data = row?.registeredEvents.at(0)?.eventEntries?.sort((a, b) => orderMap.get(a.ee_code) - orderMap.get(b.ee_code));
    /* const orderMap = new Map();
    sportEntryCodes.forEach(element => {
        orderMap.set(element?.sportCode, element?.order?.trim());
    });
    const data = row?.registeredEvents?.find(re => re.code === event)
        ?.eventEntries?.filter(item => orderMap.has(item.ee_code))
        .sort((a, b) => orderMap.get(a.ee_code) - orderMap.get(b.ee_code));
    */
    const GetParticipantName = (code) => useGetParticipantNames(params)?.persons?.find(person=>person?.code === code)?.name;
    const positions = usePositions();
    const isCodeVisible = code => (sportEntryCodes?.find(se => se?.sportCode === code)?.order > 9)
    const getSportCodeDecription = code => sportEntryCodes?.find(se => se?.sportCode === code)?.description || code;
    const getCodeValue = (codeEntry) => {
        let codeValue = "";
        switch (codeEntry.ee_code) {
            case "POSITION":
                codeValue = positions(codeEntry.ee_value);
                break;
            default:
                codeValue = codeEntry.ee_value;
                break;
        }
        return codeValue;
    }
    return (
        <table className="table table-detail">
            <thead>
                <tr>
                    {data?.map(ee => (
                        isCodeVisible(ee?.ee_code) && <th key={ee.ee_code}>{getSportCodeDecription(ee?.ee_code)}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                <tr>
                    {data?.map(ee => {
                        let entry = sportEntryCodes?.find( spEntry => spEntry?.disciplineCode === mirs_discipline && spEntry?.sportCode === ee?.ee_code);                        
                        if(isCodeVisible(ee?.ee_code) && ee.ee_code.startsWith('GUIDE')) {
                            return <td key={ee.ee_code}><b>{GetParticipantName(ee.ee_value)}</b></td>
                        }
                        return isCodeVisible(ee?.ee_code) &&  <td key={ee.ee_code}><b>{entry?.note ? GGetSportsCode(mirs_discipline, entry?.note, ee)?.description: ee?.ee_value}</b></td>
                    })}
                </tr>
            </tbody>
        </table>
    );
}, (prevProps, nextProps) => {
    //Si retornamos true:  No se renderiza
    //Si retornamos false: Si se renderiza
    return (
        //renderizamos cuando un dato de los visibles cambia
        arraysEqual(prevProps.row, nextProps.row)
    )
});